import type {IConfigLoader} from "header-bidding-client-base/modules/config/domain/iConfigLoader";
import {initGptHeaderBidding} from "../gptHeaderBiddingScript";
import {WindowConfigLoader} from "header-bidding-client-base/modules/config/infrastructure/windowConfigLoader";
import {
    MotoresPrebidJsBiddersLoader
} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/projects/motores/motoresPrebidJsBiddersLoader";

// Define dependencies
const configLoader: IConfigLoader = new WindowConfigLoader();
const prebidJSBiddersLoaderClass = MotoresPrebidJsBiddersLoader;
initGptHeaderBidding(configLoader, prebidJSBiddersLoaderClass);

